import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { BASE_URL } from "../utils/config";
import { getAuthHeaders } from "../utils/auth";
import "../styles/AddEditBlog.css";

const AddEditBlog = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = !!id;

  const [formData, setFormData] = useState({
    title: "",
    content: "",
    author: "",
    photo: "",
    featured: false,
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  useEffect(() => {
    if (isEdit) {
      fetchBlog();
    }
  }, [id]);

  const fetchBlog = async () => {
    try {
      const res = await fetch(`${BASE_URL}/blogs/${id}`);
      if (res.ok) {
        const data = await res.json();
        setFormData({
          title: data.title || "",
          content: data.content || "",
          author: data.author || "",
          photo: data.photo || "",
          featured: data.featured || false,
        });
      }
    } catch (error) {
      setError("Failed to fetch blog details");
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      const url = isEdit ? `${BASE_URL}/blogs/${id}` : `${BASE_URL}/blogs`;
      const method = isEdit ? "PUT" : "POST";

      const res = await fetch(url, {
        method,
        headers: getAuthHeaders(),
        body: JSON.stringify(formData),
      });

      if (res.ok) {
        setSuccess(isEdit ? "Blog updated successfully!" : "Blog created successfully!");
        setTimeout(() => {
          navigate("/admin/blogs");
        }, 1500);
      } else {
        const data = await res.json();
        setError(data.message || data.error || "Failed to save blog");
      }
    } catch (error) {
      setError("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-edit-blog">
      <div className="form-container">
        <h3>{isEdit ? "Edit Blog" : "Add New Blog"}</h3>

        {error && <div className="error-message">{error}</div>}
        {success && <div className="success-message">{success}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label>Blog Title *</label>
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleChange}
                required
                placeholder="Enter blog title"
              />
            </div>

            <div className="form-group">
              <label>Author Name *</label>
              <input
                type="text"
                name="author"
                value={formData.author}
                onChange={handleChange}
                required
                placeholder="Author name"
              />
            </div>
          </div>

          <div className="form-group">
            <label>Photo URL *</label>
            <input
              type="url"
              name="photo"
              value={formData.photo}
              onChange={handleChange}
              required
              placeholder="https://example.com/image.jpg"
            />
            {formData.photo && (
              <div className="image-preview">
                <img src={formData.photo} alt="Preview" />
              </div>
            )}
          </div>

          <div className="form-group">
            <label>Content *</label>
            <textarea
              name="content"
              value={formData.content}
              onChange={handleChange}
              required
              rows="12"
              placeholder="Write your blog content here..."
            />
          </div>

          <div className="form-group checkbox-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                name="featured"
                checked={formData.featured}
                onChange={handleChange}
              />
              <span>Mark as Featured Blog</span>
            </label>
          </div>

          <div className="form-actions">
            <button
              type="button"
              className="cancel-btn"
              onClick={() => navigate("/admin/blogs")}
            >
              Cancel
            </button>
            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? "Saving..." : isEdit ? "Update Blog" : "Create Blog"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddEditBlog;

